import request from '@/utils/request'

export const ledgerList = data => request({ url: '/oaApproval/ledger/list', method: 'post', data })
export const ledgerTypes = () => request({ url: '/oaApproval/ledger/types' })
export const ledgerDetail = id => request({ url: `/oaApproval/ledger/${id}` })
